<div class="close" (click)="close()">
    <mat-icon>close</mat-icon>
</div>

<component-login (loginComplete)="loginComplete($event)"></component-login>
